import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	emptyStateHeader: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	emptyStateDescription: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	seeAllIssuesAssignedToMe: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	emptyStateHeaderIssueTermRefresh: {
		defaultMessage: string;
		id: string;
		description: string;
	};
	emptyStateDescriptionIssueTermRefresh: {
		defaultMessage: string;
		id: string;
		description: string;
	};
} = defineMessages({
	emptyStateHeader: {
		defaultMessage: 'Find all your open issues in one place',
		id: 'home.tabs.assigned-to-me.empty-state-header',
		description: 'Empty State header for jira home starred tab',
	},
	emptyStateDescription: {
		defaultMessage: 'You have no open issues assigned to you',
		id: 'home.tabs.assigned-to-me.empty-state-description',
		description: 'Empty State description for jira home assigned tab',
	},
	seeAllIssuesAssignedToMe: {
		defaultMessage: 'View all',
		id: 'home.tabs.assigned-to-me.see-all-issues-assigned-to-me',
		description:
			'The label for the button that links the user to the issue search page page which shows them all of the issues that are assigned to them.',
	},
	emptyStateHeaderIssueTermRefresh: {
		defaultMessage: 'Find all your open work items in one place',
		id: 'home.tabs.assigned-to-me.empty-state-header-issue-term-refresh',
		description: 'Empty State header for jira home starred tab',
	},
	emptyStateDescriptionIssueTermRefresh: {
		defaultMessage: 'You have no open work items assigned to you',
		id: 'home.tabs.assigned-to-me.empty-state-description-issue-term-refresh',
		description: 'Empty State description for jira home assigned tab',
	},
});
export default messages;
